module.exports = __webpack_public_path__ + "img/3-112.0cae1baf.png";